import loadingText from './loadingText';
import loadingText_ar from './loadingText_ar';
import loadingText_cs from './loadingText_cs';
import loadingText_da from './loadingText_da';
import loadingText_de from './loadingText_de';
import loadingText_el from './loadingText_el';
import loadingText_es from './loadingText_es';
import loadingText_fi from './loadingText_fi';
import loadingText_fr from './loadingText_fr';
import loadingText_he from './loadingText_he';
import loadingText_hr from './loadingText_hr';
import loadingText_hu from './loadingText_hu';
import loadingText_it from './loadingText_it';
import loadingText_iw from './loadingText_iw';
import loadingText_ja from './loadingText_ja';
import loadingText_ko from './loadingText_ko';
import loadingText_nb from './loadingText_nb';
import loadingText_nl from './loadingText_nl';
import loadingText_no from './loadingText_no';
import loadingText_pl from './loadingText_pl';
import loadingText_pt_BR from './loadingText_pt-BR';
import loadingText_pt from './loadingText_pt';
import loadingText_ru from './loadingText_ru';
import loadingText_sh from './loadingText_sh';
import loadingText_sk from './loadingText_sk';
import loadingText_sl from './loadingText_sl';
import loadingText_sr from './loadingText_sr';
import loadingText_sv from './loadingText_sv';
import loadingText_th from './loadingText_th';
import loadingText_tr from './loadingText_tr';
import loadingText_zh_Hans from './loadingText_zh-Hans';
import loadingText_zh_Hant from './loadingText_zh-Hant';

const bundle = {
  '': loadingText,
  'ar': loadingText_ar,
  'cs': loadingText_cs,
  'da': loadingText_da,
  'de': loadingText_de,
  'el': loadingText_el,
  'es': loadingText_es,
  'fi': loadingText_fi,
  'fr': loadingText_fr,
  'he': loadingText_he,
  'hr': loadingText_hr,
  'hu': loadingText_hu,
  'it': loadingText_it,
  'iw': loadingText_iw,
  'ja': loadingText_ja,
  'ko': loadingText_ko,
  'nb': loadingText_nb,
  'nl': loadingText_nl,
  'no': loadingText_no,
  'pl': loadingText_pl,
  'pt-BR': loadingText_pt_BR,
  'pt': loadingText_pt,
  'ru': loadingText_ru,
  'sh': loadingText_sh,
  'sk': loadingText_sk,
  'sl': loadingText_sl,
  'sr': loadingText_sr,
  'sv': loadingText_sv,
  'th': loadingText_th,
  'tr': loadingText_tr,
  'zh-Hans': loadingText_zh_Hans,
  'zh-Hant': loadingText_zh_Hant,
};
export default bundle;
